import React from "react";
import "../../styles/home.css";
import pratner_logo1 from "../../assets/images/svg/partners_logo1.svg";
import pratner_logo2 from "../../assets/images/svg/partners_logo2.svg";
import pratner_logo3 from "../../assets/images/svg/partners_logo3.svg";
import pratner_logo4 from "../../assets/images/svg/partners_logo4.svg";
import pratner_logo5 from "../../assets/images/svg/partners_logo5.svg";
import pratner_logo6 from "../../assets/images/svg/partners_logo6.svg";
import pratner_logo7 from "../../assets/images/svg/partners_logo7.svg";
import pratner_logo8 from "../../assets/images/svg/partners_logo8.svg";
import pratner_logo9 from "../../assets/images/svg/partners_logo9.svg";
import pratner_logo10 from "../../assets/images/svg/partners_logo10.svg";
import pratner_logo11 from "../../assets/images/svg/partners_logo11.svg";
import pratner_logo12 from "../../assets/images/svg/partners_logo12.svg";
import pratner_logo13 from "../../assets/images/svg/partners_logo13.svg";
import pratner_logo14 from "../../assets/images/svg/partners_logo14.svg";
import pratner_logo15 from "../../assets/images/svg/partners_logo15.svg";
import pratner_logo16 from "../../assets/images/svg/partners_logo16.svg";
import pratner_logo17 from "../../assets/images/svg/partners_logo17.svg";
import pratner_logo18 from "../../assets/images/svg/partners_logo18.svg";

const logos = [
  pratner_logo1, pratner_logo2, pratner_logo3, pratner_logo4,
  pratner_logo5, pratner_logo6, pratner_logo7, pratner_logo8,
  pratner_logo9, pratner_logo10, pratner_logo11, pratner_logo12,
  pratner_logo13, pratner_logo14, pratner_logo15, pratner_logo16,
  pratner_logo17, pratner_logo18,
];

// Three rows of six, laid like bricks.
const rows = [0, 6, 12].map((start) => logos.slice(start, start + 6));

// A wall of logo tiles leaning back in 3D. When it scrolls into view (AOS
// adds .aos-animate) it straightens a little while the tiles flip up in a
// diagonal wave; a hovered tile lifts towards the viewer.
const Partners = () => (
  <div className="section-cream partners-section home-section-pad position-relative overflow-hidden">
    <div className="container py-md-9 position-relative">
      <div className="row justify-content-center pb-md-5">
        <div className="col-md-11">
          <h3 className="section-heading">
            <span className="live-pulse-dot" aria-hidden="true" />
            Our <span className="section-heading-accent">Partners</span>
          </h3>
          <p className="section-subtitle mb-5">
            Collaborating with Industry Leaders to Shape the Future of Media
          </p>

          <div className="pt-wall" data-aos="pt-build" data-aos-anchor-placement="center-bottom">
            <div className="pt-grid">
              {rows.map((row, r) => (
                <div className="pt-row" key={r}>
                  {row.map((logo, c) => (
                    <div className="pt-tile" style={{ transitionDelay: `${(r + c) * 0.08}s` }} key={c}>
                      <img loading="lazy" decoding="async" src={logo} alt={`partner_logo_${r * 6 + c + 1}`} />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Partners;
